import { useState, useEffect } from 'react';
import api from '../../../services/api';
import { toastSuccess, toastError } from '../../../toasts';
import { useAuth } from '../../../hooks/auth';
import { parseDataToRequest, parseChargeData } from './utils';
import { defaultFormState } from './constants';

export const useCreateEditMount = ({
  setMontagens,
  montagem,
  modal,
  close,
}) => {
  const { id_empresa } = useAuth();
  const [form, setForm] = useState(defaultFormState);
  const [openDeleteMounting, setOpenDeleteMounting] = useState(false);

  const chargeData = (montagem) => {
    setForm(parseChargeData(montagem));
  };

  /**
   * @param {keyof form} label
   */
  const onChange = (label) => {
    return (value) => {
      setForm((state) => ({ ...state, [label]: value }));
    };
  };

  const handleOpenDelete = () => {
    setOpenDeleteMounting((state) => !state);
  };

  const editarMontagem = async () => {
    if (form.incrementar <= 0) {
      toastError('Incremento deve ser maior que zero.');
    }

    try {
      const { Id } = montagem;

      const { data } = await api.patch(
        `montagem-prato/alterar/${Id}`,
        parseDataToRequest(form, id_empresa),
      );

      toastSuccess('Montagem alterada', 'Sucesso');
      setMontagens((state) => state.map((m) => (m.Id !== data.Id ? m : data)));
      close();
    } catch (error) {
      toastError('Não foi possivel editar montagem');
    }
  };

  const cadastrarMontagem = async () => {
    try {
      const { data } = await api.post(
        'montagem-prato/criar',
        parseDataToRequest(form, id_empresa),
      );

      toastSuccess('Montagem cadastrada', 'Sucesso');
      setMontagens((prevState) => [...prevState, data]);
      close();
    } catch (error) {
      toastError('Não foi possivel cadastrar montagem');
    }
  };

  const handleCheckAll = () => {
    onChange('controlaEmbalagem')(!form.controlaEmbalagem);
  };

  const onCloseDeleteMounting = () => {
    close();
    setOpenDeleteMounting(false);
  };

  useEffect(() => {
    if (montagem) {
      chargeData(montagem);
    }
  }, [modal]);

  return {
    form,
    openDeleteMounting,
    cadastrarMontagem,
    editarMontagem,
    handleCheckAll,
    onChange,
    handleOpenDelete,
    onCloseDeleteMounting,
  };
};
